import React, { Component } from "react";
import Form from "./components/Form";
import Container from "./components/Container";
import DocumentTitle from "react-document-title";

const Index = props => {
  return (
    <DocumentTitle title="Raunch – It’s time for a better cam site">
      <Container>
        <h1 className="primary line-height-3">
          It’s time for a better webcam site
        </h1>

        <p>
          Raunch is a great new place to cam. It’s simpler, more focused and
          delightful to use. We’re currently testing it with a few select
          models.
        </p>

        <p className="mb3">Sign up now for early access.</p>

        <Form {...props} />
      </Container>
    </DocumentTitle>
  );
};

export default Index;



// WEBPACK FOOTER //
// ./index.js